import { CustomerAreaSectionHeader } from '../customer-area'

type CustomerSupportHeaderProps = {
  title: string
  subtitle: string
  customerAreaLabel: string
  dashboardLabel: string
  ordersLabel: string
  onNavigateDashboard: () => void
  onNavigateOrders: () => void
}

export const CustomerSupportHeader = ({
  title,
  subtitle,
  customerAreaLabel,
  dashboardLabel,
  ordersLabel,
  onNavigateDashboard,
  onNavigateOrders,
}: CustomerSupportHeaderProps) => {
  return (
    <CustomerAreaSectionHeader
      eyebrow={customerAreaLabel}
      title={title}
      subtitle={subtitle}
      actions={
        <>
          <button
            type="button"
            onClick={onNavigateDashboard}
            className="ca-btn-secondary inline-flex h-9 items-center px-4 text-sm font-semibold"
          >
            {dashboardLabel}
          </button>
          <button
            type="button"
            onClick={onNavigateOrders}
            className="ca-btn-secondary inline-flex h-9 items-center px-4 text-sm font-semibold"
          >
            {ordersLabel}
          </button>
        </>
      }
    />
  )
}
